import * as React from 'react';

import {ChartTooltip} from 'shells/charts/chart-tooltip';

import {channelValues} from '../helpers';

type PayloadValues = {
    bucket: string;
    count: number;
};

type Props = {
    active: boolean;
    payload: {
        payload: PayloadValues[];
    };
};

export const CompetitorsBarChartTooltip = (props: Props) => {
    // @ts-expect-error
    const payload = props.active ? props.payload[0] : undefined;

    if (payload) {
        const {domainName, ...channels} = payload.payload;

        return (
            <ChartTooltip
                header={{text: domainName}}
                rows={channelValues.map((channel) => ({
                    label: channel.name,
                    value: (channels[channel.name] * 100).toFixed(1),
                    isPercentage: true,
                    dotColor: channel.fill,
                }))}
            />
        );
    }

    return <></>;
};
